import User from '@app/Interface/UserInterface';
import * as React from 'react';

interface ThemeStyleProps {
    currentUser?: User;
}

/**
 * see: https://medium.com/swlh/dynamically-import-css-d8222423f109
 */
const ThemeStyle: React.FC<ThemeStyleProps> = ({currentUser, children}) => {

    let styles: string;

    if (currentUser === undefined || currentUser?.isMember) {

        // Set the NDA member theme (also default theme for login page)
        styles = `
        :root {
            --nda-background-theme--Color: #8ECDED;
            --nda-primary-theme--Color: #c20430;
            --nda-accent-theme--Color: #F4F3ED;
            --nda-primary-text--Color: #414241;
            --nda-tertiary-theme--Color: #97663F;
          }
        `;

    } else {

        // set the Lab member theme
        styles = `
        :root {
            --nda-background-theme--Color: #F4F3ED;
            --nda-primary-theme--Color: #689f38;
            --nda-accent-theme--Color: #F4F3ED;
            --nda-primary-text--Color: #414241;
            --nda-tertiary-theme--Color: #97663F;
          }

          .pf-c-button, .pf-c-button.pf-m-primary:active, .pf-c-button.pf-m-primary.pf-m-active, .pf-c-button.pf-m-primary:focus {
            --pf-c-button--m-primary--Color: #000000;
            --pf-c-button--m-primary--hover--Color: #000000;
          }
        `;

    }

    return (
        <style>{styles}{children}</style>
    );

};

export default ThemeStyle;